'use client';

import { CSSProperties, ReactNode } from 'react';
import { T } from '@/lib/tokens';

type Variant = 'primary' | 'secondary' | 'ghost' | 'sage';

type Props = {
  onClick?: () => void;
  children: ReactNode;
  variant?: Variant;
  disabled?: boolean;
  small?: boolean;
};

export function Btn({
  onClick,
  children,
  variant = 'primary',
  disabled,
  small,
}: Props) {
  const base: CSSProperties = {
    border: 'none',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontFamily: 'inherit',
    fontWeight: 500,
    borderRadius: 8,
    transition: 'all 0.15s',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    opacity: disabled ? 0.45 : 1,
  };
  const pad = small ? '8px 16px' : '12px 28px';
  const fs = small ? 13 : 15;
  const styles: Record<Variant, CSSProperties> = {
    primary: { ...base, background: T.terra, color: T.white, padding: pad, fontSize: fs },
    secondary: {
      ...base,
      background: T.creamMid,
      color: T.espresso,
      padding: pad,
      fontSize: fs,
    },
    ghost: {
      ...base,
      background: 'transparent',
      color: T.espressoLight,
      padding: small ? '6px 12px' : '10px 20px',
      fontSize: fs,
      textDecoration: 'underline',
    },
    sage: { ...base, background: T.sage, color: T.white, padding: pad, fontSize: fs },
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={styles[variant]}
      onMouseEnter={(e) => {
        if (!disabled) e.currentTarget.style.filter = 'brightness(0.92)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.filter = '';
      }}
    >
      {children}
    </button>
  );
}
